import { render, staticRenderFns } from "./print-media-supplier-apply.vue?vue&type=template&id=553c8130&scoped=true"
import script from "./print-media-supplier-apply.vue?vue&type=script&lang=ts"
export * from "./print-media-supplier-apply.vue?vue&type=script&lang=ts"
import style0 from "./print-media-supplier-apply.vue?vue&type=style&index=0&id=553c8130&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553c8130",
  null
  
)

export default component.exports